import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from './ChangePlanModal.styles';
import {
  Button, IconSearchFail, Modal,
  TextField,
} from 'gatorcomponents';

import PropTypes from 'prop-types';

export const ChangePlanModal = ({
  sites,
  onClose,
  currentPlan,
  handleSetPlan,
  backCta = 'Voltar',
  continueCta = 'Continuar',
  title = 'Selecione um domínio',
  emptyMessage = 'Nenhum resultado encontrado para sua busca',
  searchPlaceholder = 'Buscar por domínio',
}) => {
  const [inputedFilter, setInputedFilter] = useState('');
  const [selectedItem, setSelectedItem] = useState(currentPlan);

  const [filteredDomains, setFilteredDomains] = useState(sites);

  const filterCards = useCallback(() => {
    setFilteredDomains(sites.filter(item => item.domain.toLowerCase().includes(inputedFilter.toLowerCase())));
  }, [
    inputedFilter,
    sites,
  ]);

  useEffect(() => {
    filterCards();
  }, [filterCards]);

  const handleChangePlan = () => {
    handleSetPlan && handleSetPlan(selectedItem);
    onClose && onClose();
  };

  const handleSelect = (item) => {
    setSelectedItem(item);
  };

  return (
    <Modal
      title={title}
      onClose={onClose}
      maxHeight={472}
      maxWidth={847}
    >

      <TextField
        label={searchPlaceholder}
        placeholder="Digite o domínio"
        onChange={e => setInputedFilter(e.target.value)}
        value={inputedFilter}
        traillingIcon="IconSearch"
      />
      <Styles.DomainsWrapper>
        {!!(filteredDomains.length) && filteredDomains.map((item, index) => {
          const isSelected = item.hosting_id === selectedItem.hosting_id
                  && item.domain === selectedItem.domain;

          return (
            <React.Fragment
              key={`${item.product_name}_${item.domain}`}
            >
              <Styles.DomainItem
                isSelected={isSelected}
                onClick={() => handleSelect(item)}
              >
                <Styles.Domain isSelected={isSelected}>
                  {item.domain}
                </Styles.Domain>

                <Styles.Plan isSelected={isSelected}>
                  {`Hospedagem: ${item.product_name}`}
                </Styles.Plan>

              </Styles.DomainItem>
              {(index < filteredDomains.length - 1 && !isSelected) && <Styles.Divider />}
            </React.Fragment>
          );
        })}


        {!filteredDomains.length && (
        <Styles.EmptyStateWrapper>
          <IconSearchFail color="lowLight" />
          <Styles.EmptyStateMessage>
            {emptyMessage}
          </Styles.EmptyStateMessage>
        </Styles.EmptyStateWrapper>
        )}

      </Styles.DomainsWrapper>

      <Styles.ButtonWrapper>
        <Button
          size="medium2"
          variant="tertiary"
          label={backCta}
          onClick={() => onClose()}
        />

        <Button
          testId="changePlan"
          label={continueCta}
          size="medium2"
          variant="primary"
          onClick={handleChangePlan}
        />
      </Styles.ButtonWrapper>
    </Modal>
  );
};

ChangePlanModal.propTypes = {
  sites: PropTypes.arrayOf(PropTypes.shape({
    domain: PropTypes.string,
    hosting_id: PropTypes.string,
    product_name: PropTypes.string,
  })).isRequired,
  onClose: PropTypes.func.isRequired,
  currentPlan: PropTypes.shape({
    domain: PropTypes.string,
    hosting_id: PropTypes.string,
    product_name: PropTypes.string,
  }).isRequired,
  handleSetPlan: PropTypes.func.isRequired,
  backCta: PropTypes.string,
  continueCta: PropTypes.string,
  title: PropTypes.string,
  emptyMessage: PropTypes.string,
};

export default ChangePlanModal;
